import { Component, ComponentFactoryResolver, OnInit } from "@angular/core";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { ReelsService } from "../../../../services/reels.service";
import { SwalService } from "../../../../shared/services/swal.service";
import { BroadcastService } from "../../../../shared/services/broadcast.service";
import { NRModalService } from "../../../../shared/modal/services/nrmodal.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomersService } from "../../../../services/customers.service";
import { ControlService } from "../../../../services/control.service";
import { MediasService } from "../../../../services/medias.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import {
	EventModel,
	EventSubscriptionType,
	EventType,
} from "../../../../shared/interfaces/event.model";
import { DynamicHostModel } from "../../../../shared/modal/models/dynamic-host.model";
import { CreateEditReelComponent } from "../../../admin/svs/reels/create-edit-reel/create-edit-reel.component";
import { EditCreateMediaComponent } from "../../../admin/svs/media/edit-create-media/edit-create-media.component";

export interface MediaItem {
	id: number;
	name: string;
	path: string;
	description: string | null;
	type: "VIDEO" | "IMAGE" | string;
	fecha: string; // fecha de inicio de vigencia (ISO)
	vigencia: string; // fecha de fin de vigencia (ISO)
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
	thumb: string | null;
	size: string | null;
	duration_seconds: number | null;
	checksum: string | null;
	client_id: number;
	resource_url: string;
	thumb_url: string;
	total_views_value: number;
	categories: MediaCategory[];
	total_views: MediaTotalViews | null;
	media_views: MediaView[];
}

/* 
  Representa una categoría asociada al media (p. ej. “COMERCIAL”, “GENÉRICA”).
*/
export interface MediaCategory {
	id: number;
	name: string;
	description: string;
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
	pivot?: {
		media_id: number;
		category_id: number;
		created_at: string;
		updated_at: string;
	};
}

/* 
  Representa el total de vistas acumuladas del media.
*/
export interface MediaTotalViews {
	media_id: number;
	total: string; // normalmente viene como string en la respuesta
}

/* 
  Representa una vista individual (registro histórico o diario).
*/
export interface MediaView {
	// puedes extender según lo que devuelva tu endpoint de media_views
	id?: number;
	date_view?: string;
	total_view?: number;
}

@Component({
	selector: "app-design-reels",
	templateUrl: "./design-reels.component.html",
	styleUrls: ["./design-reels.component.scss"],
})
export class DesignReelsComponent implements OnInit {
	isAdmin: boolean = false;
	clientes: any[] = [];
	medias: any[] = [];
	photos: any[] = [];
	selectedClientId: number | null = null;
	selectedReel: any[] | null = null;
	selectedReelName: string | null = null;
	selectedReelId: number | null = null;
	canAddGroup: boolean | true = true;

	CurrentType: string | null = null;

	Group_id: number | null = null;

	ReelsByUser = [];

	searchTerm: string = "";
	soloVigentes: boolean = true;
	message: string = "Cargando...";
	isLoading: boolean = false;
	isLoadingRepertorio: boolean = false;

	reelsDisponibles = [
		{
			id: 1,
			name: "Campaña Octubre Pepsi",
			descripcion: "Promos 2x1",
			items: [
				/* ...clips... */
				"prueba",
			],
			thumbs: [
				"url-thumb-1.jpg",
				"url-thumb-2.jpg",
				"url-thumb-3.jpg",
				"url-thumb-4.jpg",
			],
		},
		{
			id: 2,
			name: "Campaña Octubre coca",
			descripcion: "Promos 2x1",
			medias: [
				/* ...clips... */
			],
			thumbs: [
				"url-thumb-1.jpg",
				"url-thumb-2.jpg",
				"url-thumb-3.jpg",
				"url-thumb-4.jpg",
			],
		},
	];

	repertorio: MediaItem[] = [];
	repertorioBase: MediaItem[] = [];

	reelTimeline: MediaItem[] = [];
	reelTimelineBase: MediaItem[] = [];
	totalDurationSelected: string = null;

	private atComponentDestroy = new Subject();

	constructor(
		private reelsService: ReelsService,
		private mediasService: MediasService,
		private swal: SwalService,
		private broadcast: BroadcastService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private nrModal: NRModalService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private customerService: CustomersService,
		private controlService: ControlService,
	) {
		if (this.activatedRoute.snapshot.params["id"]) {
			this.Group_id = this.activatedRoute.snapshot.params["id"];
		} else {
			console.warn("Sin grupo");
		}
	}

	async ngOnInit(): Promise<void> {
		this.atComponentDestroy.next(true);
		this.message = "Cargando...";
		this.isLoading = true;
		this.controlService.isAdmin().subscribe((res) => {
			this.isAdmin = res.is_admin;
		});

		await this.obtenerReel();

		this.broadcast
			.onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((event: EventModel) => {
				const props = this.prepareProps(event);
				if (props) {
					this.nrModal.open(
						props,
						props.modalModel?.modalConfiguration?.modalSize || "xl",
					);
				}
			});
		this.broadcast
			.onEvent(EventSubscriptionType.TYPE, EventType.DATATABLE)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((event: EventModel) => {
				this.obtenerReel();
				this.getMedias();
			});

		this.customerService.getLimits().then((res: any) => {
			const reelsLimit = res.reels || { used: 0, limit: 0 };
			this.canAddGroup = reelsLimit.used < reelsLimit.limit;
		});

		this.isLoading = false;
	}

	prepareProps(event: EventModel): any {
		const props: DynamicHostModel = new DynamicHostModel();
		props.instantiated = false;
		props.modalModel = {
			component: null,
			componentFactoryResolver: this.componentFactoryResolver,
			data: event.data.item || {},
		};

		switch (event.name) {
			case "reels.add":
				props.modalModel.component = CreateEditReelComponent;
				props.modalModel.modalConfiguration = {
					title: "Agregar Reel",
				};
				props.modalModel.data = {
					is_admin: this.isAdmin,
				};
				break;
			case "medias.add":
				props.modalModel.component = EditCreateMediaComponent;
				props.modalModel.modalConfiguration = {
					title: "Agregar Media",
				};
				props.modalModel.data = { IsAdmin: this.isAdmin, item: {} };
				break;
			case "reels.edit":
				props.modalModel.component = CreateEditReelComponent;
				props.modalModel.modalConfiguration = {
					title: "Editar Reel",
				};
				const reel = {
					...this.selectedReel,
					medias: [],
				};

				props.modalModel.data = {
					is_admin: this.isAdmin,
					...this.selectedReel,
				};
				break;
			default:
				return false;
		}

		return props;
	}

	async obtenerReel() {
		try {
			var reel;
			if (this.Group_id) {
				reel = await this.reelsService.ShowByGroup(this.Group_id);
			} else {
				reel = await this.reelsService.showAll();
			}
			this.ReelsByUser = reel;

			const result = await this.mediasService.showAll();
			let medias = result.data;

			this.ReelsByUser.forEach(async (reel) => {
				const response = await this.reelsService.show(reel.id);
				reel.medias = response.response.medias;

				const totalDuration = reel.medias.reduce(
					(acc: number, media: any) => {
						const duration = Number(media.duration_seconds) || 0;
						return acc + duration;
					},
					0,
				);

				// Guardar el total en el mismo objeto (por ejemplo)
				reel.totalDuration = this.formatDuration(totalDuration);
			});
		} catch (error) {
			console.error("Error al obtener el reel:", error);
		}
	}

	async getMedias() {
		if (this.medias === this.repertorioBase) {
			this.isLoading = true;
			const result = await this.mediasService.getMediasByType("VIDEO");
			this.repertorio = result;
			this.repertorioBase = result;
			this.medias = result;
			this.isLoading = false;
		} else {
			this.mediasService.getMediasByType("VIDEO").then((data) => {
				this.medias = data;
			});
		}

		if (this.photos === this.repertorioBase) {
			this.isLoading = true;
			const result = await this.mediasService.getMediasByType("IMAGE");

			this.repertorio = result;
			this.repertorioBase = result;
			this.photos = result;
			this.isLoading = false;
		} else {
			this.mediasService.getMediasByType("IMAGE").then((data) => {
				this.photos = data;
			});
		}
	}

	removeFromTimeline(index: number, clip: any) {
		if (index > -1 && index < this.reelTimeline.length) {
			this.reelTimeline.splice(index, 1);
			this.removeDuration(clip.duration_seconds);
		}
	}

	formatDuration(seconds: number | null | undefined): string {
		if (!seconds || seconds < 0) return "00:00";

		const mins = Math.floor(seconds / 60);
		const secs = Math.floor(seconds % 60);

		const pad = (n: number) => n.toString().padStart(2, "0");
		return `${pad(mins)}:${pad(secs)}`;
	}

	filterRepertorio(): void {
		const term = this.searchTerm.trim().toLowerCase() || "";

		this.repertorio = this.repertorioBase.filter((media) => {
			const coincideTexto =
				!term || media.name.toLowerCase().includes(term);

			/* Filtro por vigencia */
			const coincideVigencia =
				!this.soloVigentes || this.puedeArrastrarMedia(media);

			return coincideTexto && coincideVigencia;
		});
	}

	onDropTimeline(event: CdkDragDrop<MediaItem[]>) {
		const fromList = event.previousContainer.data;
		const toList = event.container.data;

		const isSameList = event.previousContainer === event.container;

		if (isSameList) {
			// reorder interno en timeline
			moveItemInArray(toList, event.previousIndex, event.currentIndex);
			return;
		}

		// viene desde repertorio -> timeline
		const draggedItem = fromList[event.previousIndex];
		this.addDuration(draggedItem.duration_seconds);

		const cloned: MediaItem = {
			...draggedItem,
			id: draggedItem.id,
		};

		toList.splice(event.currentIndex, 0, cloned);
	}

	addDuration(draggedSeconds: number): void {
		const currentSeconds = this.timeToSeconds(this.totalDurationSelected);
		const newTotal = currentSeconds + draggedSeconds;

		this.totalDurationSelected = this.formatDuration(newTotal);
	}

	removeDuration(secondsToRemove: number): void {
		const currentSeconds = this.timeToSeconds(this.totalDurationSelected);
		let newTotal = currentSeconds - secondsToRemove;

		if (newTotal < 0) {
			newTotal = 0;
		}

		this.totalDurationSelected = this.formatDuration(newTotal);
	}

	private timeToSeconds(time: string): number {
		if (!time) return 0;
		const [mm, ss] = time.split(":").map(Number);
		return mm * 60 + ss;
	}

	onDropRepertorio(event: CdkDragDrop<MediaItem[]>) {
		// catálogo fijo, no hacemos nada
		return;
	}

	saveTimeline() {
		this.message = "Guardando Reel...";
		this.isLoading = true;
		// lógica para guardar el orden del reel
		let selectedValues = [];
		this.reelTimeline.forEach((element) => {
			selectedValues.push(element.id);
		});

		this.reelsService
			.saveMedias({ medias: selectedValues }, this.selectedReelId)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((data) => {
				this.isLoading = false;
				this.swal.success();
				this.ngOnInit();
			});
	}

	cancelTimeline() {
		// lógica para revertir o salir sin guardar
		this.reelTimeline = [...this.reelTimelineBase];
	}

	edit_reel(): void {
		this.broadcast.fire({
			name: "reels.edit",
			type: EventType.MODAL,
			data: {},
		});
	}

	puedeArrastrarMedia(media: any): boolean {
		if (!media?.vigencia) {
			return false;
		}

		/* Fecha de vigencia (UTC) */
		const fechaVigencia = new Date(media.vigencia);

		/* Fecha actual */
		const ahora = new Date();

		/* Arrastrable solo si aún no vence */
		return ahora < fechaVigencia;
	}

	isDisabled(reel: any): boolean {
		/* Arrastrable solo si aún no vence */
		return reel.active != 0;
	}

	async selectReel(r: any) {
		this.isLoadingRepertorio = true;
		// ejemplo: cargar el reel seleccionado a la línea de tiempo actual
		this.reelTimeline = [...r.medias];
		this.reelTimelineBase = [...r.medias];
		console.log(this.reelTimelineBase);
		this.selectedReelId = r.id;
		this.selectedReelName = r.name;
		this.selectedReel = r;
		this.totalDurationSelected = r.totalDuration;

		if (r.type != this.CurrentType) {
			this.CurrentType = r.type;
			if (r.type === "VIDEO") {
				if (this.medias.length > 0) {
					this.repertorio = [...this.medias];
					this.repertorioBase = [...this.medias];
				} else {
					const result = await this.mediasService.getMediasByType(
						r.type,
					);
					this.repertorio = result;
					this.repertorioBase = result;
					this.medias = result;
				}
			} else {
				if (this.photos.length > 0) {
					this.repertorio = [...this.photos];
					this.repertorioBase = [...this.photos];
				} else {
					const result = await this.mediasService.getMediasByType(
						r.type,
					);
					this.repertorio = result;
					this.repertorioBase = result;
					this.photos = result;
				}
			}
		}
		this.filterRepertorio();
		this.isLoadingRepertorio = false;
	}

	createNewReel(): void {
		this.broadcast.fire({
			name: "reels.add",
			type: EventType.MODAL,
			data: {},
		});
	}

	createNewMedia(): void {
		this.broadcast.fire({
			name: "medias.add",
			type: EventType.MODAL,
			data: {},
		});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next(true);
		this.atComponentDestroy.unsubscribe();
	}

	hasExpiredItems(): boolean {
		return (
			this.reelTimeline?.some(
				(clip: any) => !this.puedeArrastrarMedia(clip),
			) ?? false
		);
	}

	/* Elimina de la línea de tiempo todos los elementos vencidos */
	removeExpiredFromTimeline(): void {
		if (!this.reelTimeline || this.reelTimeline.length === 0) {
			return;
		}

		this.reelTimeline = this.reelTimeline.filter((clip: any) =>
			this.puedeArrastrarMedia(clip),
		);
	}

	removeAllFromTimeline(): void {
		if (!this.reelTimeline || this.reelTimeline.length === 0) {
			return;
		}

		this.reelTimeline = [];
	}
}
